// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"51c77184","82":"41773ad8","729":"f891824c","791":"23c0cd7d"}[chunkId] + ".chunk.js";
};